export default "__VITE_ASSET__BGhFmUnA__"